<template>
  <v-card flat>
    <v-card-text v-if="tab.description" class="grey lighten-4">
      <p>{{tab.description}}</p>
    </v-card-text>
    <v-divider v-if="tab.description"></v-divider>
    <section class="scroll-box">
      <v-container align="center" class="pa-0">
        <v-row align="center" :justify="'center'">
          <v-col cols="6" sm="4" class="text-center py-0">
            <div class="py-12 text-center">
              <v-btn fab :color="section.button_color" :dark="isButtonDark" @click="onClick">
                <v-icon>fa-plus</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-card>
</template>

<script>
export default {
  name: "PortalTemplatePhotoTab",
  props: ["value", "section"],
  data() {
    return {
      uploads: [],
      slide: ""
    };
  },
  computed: {
    tab() {
      return this.value;
    },
    isButtonDark() {
      return this.$helpers.lightOrDark(this.section.button_color) === "dark";
    }
  },
  methods: {
    onClick() {
      alert("This is a preview only");
    }
  }
};
</script>

<style scoped lang="scss">
.sheetbox {
  align-items: center;
  justify-content: center;
  display: flex;
}
.item-delete {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 201;
}
</style>